import {
	Button,
	Modal,
	ModalBody,
	ModalContent
} from "@heroui/react";
import {useEffect} from 'react';
import {useLocalStorage} from '@mantine/hooks';

export default function ConfirmDeductionModal({children, isOpen = false, message = "", onClosed, onConfirm, ...props}) {
	const [isHideCreditPopup, setIsHideCreditPopup] = useLocalStorage({
		key: 'is_hide_credit_popup',
		defaultValue: false,
	});

	useEffect(() => {
		if (isOpen && isHideCreditPopup) {
			onConfirm?.(true);
		}
	}, [isOpen, isHideCreditPopup, onConfirm]);

	const handleClose = () => {
		if (typeof onClosed === "function") {
			onClosed(true);
		}
	};

	return (
		<Modal
			isDismissable={false}
			hideCloseButton
			backdrop="blur"
			size="lg"
			classNames={{
				base: 'overflow-hidden rounded-3xl border border-[#12131714] bg-white shadow-2xl',
				body: 'p-0',
			}}
			isOpen={!isHideCreditPopup && isOpen}
			onOpenChange={(open) => { if (!open) handleClose(); }}>
			<ModalContent>
				{(onClose) => (
					<ModalBody>
						{/* Hero band — caution themed with a pulsing alert badge */}
						<div className="relative overflow-hidden bg-gradient-to-br from-[#f59e0b] via-[#f5a623] to-[#fbbf24] px-8 pt-9 pb-12">
							<div className="pointer-events-none absolute -top-10 -right-8 h-32 w-32 rounded-full bg-white/15 blur-2xl" />
							<div className="pointer-events-none absolute -bottom-12 -left-6 h-32 w-32 rounded-full bg-white/10 blur-2xl" />

							<div className="relative flex flex-col items-center text-center">
								<div className="relative grid h-16 w-16 place-items-center">
									<span className="absolute inset-0 rounded-2xl bg-white/30 animate-ping" />
									<span className="relative grid h-16 w-16 place-items-center rounded-2xl bg-white/20 backdrop-blur-sm ring-1 ring-white/40">
										<i className="hgi-stroke hgi-alert-01 text-3xl text-white"></i>
									</span>
								</div>
								<h2 className="mt-4 text-xl font-semibold text-white">Please confirm</h2>
								<p className="mt-1 max-w-sm text-sm font-light text-white/85">
									This action may use some of your credits.
								</p>
							</div>
						</div>

						{/* Message */}
						<div className="px-6 pt-5">
							<div className="flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4">
								<i className="hgi-stroke hgi-coins-01 mt-0.5 text-lg text-amber-500"></i>
								<p className="text-sm font-light leading-relaxed text-amber-700">
									{message || "Proceeding with editing this segment may lead to a deduction of credits from your account. Are you sure you want to continue?"}
								</p>
							</div>
						</div>

						{/* Actions */}
						<div className="flex flex-wrap items-center justify-between gap-3 px-6 py-5">
							<Button
								variant="light"
								className="h-11 rounded-xl px-3 text-sm font-medium text-slate-500 hover:text-slate-700"
								onPress={() => {
									setIsHideCreditPopup(true);
									if (typeof onConfirm === "function") {
										onConfirm(true);
									}
								}}>
								Yes, don&apos;t show again
							</Button>
							<div className="flex items-center gap-3">
								<Button
									variant="bordered"
									className="h-11 rounded-xl border-1 border-[#00000014] bg-[#c8ceda4d] px-6 text-sm font-medium text-slate-700 hover:border-slate-700"
									onPress={() => {
										if (typeof onClosed === "function") {
											onClosed(true);
										}
									}}>
									No
								</Button>
								<Button
									className="h-11 rounded-xl bg-[#f59e0b] px-6 text-sm font-medium text-white shadow-lg shadow-[#f59e0b40] transition hover:opacity-95"
									onPress={() => {
										if (typeof onConfirm === "function") {
											onConfirm(true);
										}
									}}>
									Yes, continue
								</Button>
							</div>
						</div>
					</ModalBody>
				)}
			</ModalContent>
		</Modal>
	);
}
